import type { Namespace } from '../types';

// Device history — historical time-series per microcontroller (R-086). DE drafted.
export const deviceHistory = {
  title: { de: 'Geräteverlauf', en: 'Device History' },
  desc: {
    de: 'Historische Sensor-, Zustands- und Störungsdaten eines Mikrocontrollers aus der Zeitreihen-Datenbank.',
    en: 'Historical sensor, state and fault data for a microcontroller from the time-series database.',
  },

  device: { de: 'Gerät', en: 'Device' },
  metric: { de: 'Messgröße', en: 'Metric' },
  range: { de: 'Zeitraum', en: 'Range' },
  noDevices: { de: 'Keine Geräte', en: 'No devices' },
  searchDevice: { de: 'Gerät oder MAC suchen …', en: 'Search device or MAC…' },
  searchMetric: { de: 'Messgröße suchen …', en: 'Search metric…' },
  refreshing: { de: 'Wird aktualisiert …', en: 'Updating…' },

  pickDevice: { de: 'Gerät wählen', en: 'Select a device' },
  pickDeviceMsg: {
    de: 'Wähle oben einen Mikrocontroller, um seinen Verlauf zu sehen.',
    en: 'Pick a microcontroller above to see its history.',
  },

  seriesAvg: { de: 'Mittel', en: 'Average' },
  seriesMin: { de: 'Min', en: 'Min' },
  seriesMax: { de: 'Max', en: 'Max' },

  actuatorEvents: { de: 'Aktor-Ereignisse', en: 'Actuator events' },
  healthEvents: { de: 'Health-Ereignisse', en: 'Health events' },
  faultEvents: { de: 'Störungen', en: 'Faults' },
  noneInRange: { de: 'Keine Ereignisse im Zeitraum.', en: 'No events in range.' },
  eventsError: { de: 'Ereignisse konnten nicht geladen werden.', en: 'Could not load these events.' },
  cmdFailed: { de: 'Befehl fehlgeschlagen', en: 'Command failed' },
  parentBoard: { de: 'Parent', en: 'Parent' },
  childBoard: { de: 'Child', en: 'Child' },
  uptime: { de: 'Laufzeit {value}', en: 'Up {value}' },
  sevInfo: { de: 'Info', en: 'Info' },
  sevWarn: { de: 'Warnung', en: 'Warning' },
  sevError: { de: 'Fehler', en: 'Error' },
  sevFatal: { de: 'Kritisch', en: 'Fatal' },
  codeActuatorTimeout: { de: 'Aktor-Zeitüberschreitung', en: 'Actuator timeout' },
  codeOvercurrent: { de: 'Überstrom', en: 'Overcurrent' },
  codeBusError: { de: 'Busfehler', en: 'Bus error' },
  codeSensorFault: { de: 'Sensorfehler', en: 'Sensor fault' },

  on: { de: 'An', en: 'On' },
  off: { de: 'Aus', en: 'Off' },
  online: { de: 'Online', en: 'Online' },
  offline: { de: 'Offline', en: 'Offline' },

  // The backend caps every history read at 5,000 rows and cuts at the TAIL, so
  // an unflagged truncation looks exactly like a farm whose boards went quiet.
  // Said on the panel it applies to, not once for the page.
  truncated: { de: 'Zeitraum gekürzt', en: 'Range cut short' },
  truncatedMsg: {
    de: 'Es wurden mehr Datensätze gefunden, als übertragen werden können — die ältesten fehlen. Zeitraum verkleinern.',
    en: 'More records matched than can be returned — the oldest are missing. Narrow the range.',
  },
  truncatedSeriesMsg: {
    de: 'Es wurden mehr Messwerte gefunden, als übertragen werden können — die Kurve ist unvollständig. Zeitraum verkleinern oder gröbere Auflösung wählen.',
    en: 'More readings matched than can be returned — this curve is incomplete. Narrow the range or pick a coarser resolution.',
  },

  noData: { de: 'Keine Daten', en: 'No data' },
  noDataMsg: {
    de: 'Für diese Messgröße im gewählten Zeitraum liegen keine Werte vor.',
    en: 'No readings for this metric in the selected range.',
  },
  loadError: { de: 'Verlauf nicht erreichbar', en: 'History unavailable' },
  loadErrorMsg: {
    de: 'Der Verlauf konnte nicht geladen werden. Bitte erneut versuchen.',
    en: 'The history could not be loaded. Please retry.',
  },
} as const satisfies Namespace;
